document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('coloring-print-modal');
  const image = document.getElementById('print-modal-image');

  if (!modal || !image) return;

  /* ================= OPEN MODAL ================= */
  document.querySelectorAll('.print-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const src = this.dataset.img;
      if (!src) return;

      image.src = src;
      modal.classList.add('active');
      document.body.classList.add('modal-open');
    });
  });

  /* ================= CLOSE MODAL ================= */
  function closePrintModal() {
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
  }

  modal.querySelectorAll('.print-modal-close').forEach(btn => {
    btn.addEventListener('click', closePrintModal);
  });

  modal.addEventListener('click', function (e) {
    if (!e.target.closest('.print-modal-content')) {
      closePrintModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePrintModal();
    }
  });

  /* ================= PRINT (MOBILE SAFE) ================= */
  document.querySelectorAll('.print-confirm-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      if (!image.src) return;

      // Remove old print container
      const old = document.getElementById('print-container');
      if (old) old.remove();

      // Create print container
      const container = document.createElement('div');
      container.id = 'print-container';

      const printImg = document.createElement('img');
      printImg.src = image.src;

      container.appendChild(printImg);
      document.body.appendChild(container);

      // Wait for image to load (CRITICAL)
      printImg.onload = () => {
        container.getBoundingClientRect(); // force reflow

        setTimeout(() => {
          window.print();

          setTimeout(() => {
            container.remove();
          }, 1000);
        }, 300);
      };
    });
  });

});
